/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-globals */
import IDerivative from '@/models/vehicle/interfaces/derivative.d';
import { store } from '@/store';

class PricingService {
  private static serviceInstance: PricingService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  public calculateAverageSavingsPercentage(): number {
    const derivatives: IDerivative[] = store.getters['postEnquiryModule/derivatives'];
    const percentSavings: number[] = [];
    let parsedSaving: number = 0;

    if (derivatives) {
      derivatives.forEach((derivative) => {
        if (derivative.averagePrice < derivative.mrp && derivative.averagePrice > 0) {
          const difference = ((derivative.mrp - derivative.averagePrice) / derivative.mrp) * 100;
          percentSavings.push(difference);
        }
      });

      if (percentSavings.length > 0) {
        const averagePercentSaving = (percentSavings.reduce((previousValue, currentValue) => previousValue + currentValue, 0) / percentSavings.length).toFixed(1);
        parsedSaving = parseFloat(averagePercentSaving);
      }
    }

    return parsedSaving > 0 && !isNaN(parsedSaving) ? parsedSaving : 0;
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const pricingService = PricingService.instance;
